var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-birthday-years.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "birthdayYears")) {
output += "\n\n    <div class=\"g-loyalty-form__field-birthday-year\">\n\n        <div class=\"c-form__field ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")?(lineno = 4, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "hasErrors"), "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")),"errors")),"messages")),"dateOfBirth")])):""), env.opts.autoescape);
output += " c-loyalty__birthday-field\">\n\n            <label for=\"loyalty-birthday-year\" class=\"u-off-screen-hidden\">\n                ";
output += runtime.suppressValue((lineno = 7, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_birthday-label-year"])), env.opts.autoescape);
output += "\n            </label>\n\n            <select ";
output += runtime.suppressValue((lineno = 10, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "validatedSelect"), "validatedSelect", context, ["ERROR_CORE_REQUIRED_FIELD_ERROR",runtime.makeKeywordArgs({"field": (lineno = 10, colno = 82, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.loyaltyForm.errors.messages.dateOfBirth"]))})])), env.opts.autoescape);
output += "\n                id=\"loyalty-birthday-year\"\n                name=\"dateOfBirth\"\n                class=\"c-form__select c-loyalty__birthday-select js-loyalty-birthday-year\"\n                data-qa-loyalty-signup-birthday-year\n                aria-describedby=\"loyalty-birthday-year_error\">\n\n                <option value=\"\" disabled selected hidden>\n                    ";
output += runtime.suppressValue((lineno = 18, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_year-option"])), env.opts.autoescape);
output += ":\n                </option>";
frame = frame.push();
var t_3 = env.getFilter("reverse").call(context, runtime.contextOrFrameLookup(context, frame, "birthdayYears"));
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("year", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "<option value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"value"), env.opts.autoescape);
output += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "value") == runtime.memberLookup((t_4),"value")) {
output += " selected ";
;
}
output += ">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += "</option>";
;
}
}
frame = frame.pop();
output += "</select>\n\n                ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")?(lineno = 27, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displayFieldErrors"), "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")),"errors")),"messages")),"dateOfBirth"),runtime.makeKeywordArgs({"id": "loyalty-birthday-year"})])):""), env.opts.autoescape);
output += "\n\n        </div>\n\n    </div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-birthday-years.j2"] , dependencies)